import { instance, systemApi } from '../axios-instance'
import { getAuthToken, setAuthCookie, setAuthToken } from '@/utils/authToken.js'
// import Cookies from 'js-cookie'
// import {projectSetter} from '@store/projects'
// import qs from "qs";
import { useRoute } from 'vue-router'
import { watchersGetter, watchersSetter } from '@store/watchers.js'

function parseDate(str) {
  const [year, month, day] = str.split('-').map(Number);
  return new Date(year, month - 1, day); // monthIndex: 0 = январь
}
const normalizeText = value =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/ё/g, 'е')

const unwrapAthlete = athleteLike =>
  athleteLike && typeof athleteLike === 'object' && 'athlete' in athleteLike
    ? athleteLike.athlete
    : athleteLike || {}

const athleteIdentity = athleteLike => {
  const athlete = unwrapAthlete(athleteLike)
  const id = athlete?.id || athlete?.athleteId
  if (id) return `id:${id}`

  const fullName = athlete?.fullName || {}
  const lastName = normalizeText(fullName?.lastName)
  const firstName = normalizeText(fullName?.firstName)
  const patronymic = normalizeText(fullName?.patronymic)
  if (lastName || firstName || patronymic) {
    return `name:${lastName}|${firstName}|${patronymic}`
  }
  return ''
}

const competitorIdentity = item => {
  const athletes = Array.isArray(item?.athletes) ? item.athletes : []
  const pairKey = athletes
    .map(athleteIdentity)
    .filter(Boolean)
    .sort()
    .join('__')
  if (pairKey) return pairKey
  const number = item?.number ?? ''
  return `number:${number}`
}
const HEATS_REQUEST_TIMEOUT_MS = 7000
const SEARCH_HEATS_MAX_ROUNDS = 2

const mergeCompetitorData = (base, incoming) => {
  if (!base || !incoming) return base

  if ((base.number == null || base.number === '') && incoming.number != null) {
    base.number = incoming.number
  }
  if ((base.place == null || base.place === '') && incoming.place != null) {
    base.place = incoming.place
  }
  if (!base.club && incoming.club) {
    base.club = incoming.club
  }
  if (!base.city && incoming.city) {
    base.city = incoming.city
  }
  if (!base.country && incoming.country) {
    base.country = incoming.country
  }
  if ((!Array.isArray(base.dances) || !base.dances.length) && Array.isArray(incoming.dances)) {
    base.dances = incoming.dances
  }

  const baseAthletes = Array.isArray(base.athletes) ? base.athletes : []
  const incomingAthletes = Array.isArray(incoming.athletes) ? incoming.athletes : []
  const len = Math.max(baseAthletes.length, incomingAthletes.length)

  for (let i = 0; i < len; i += 1) {
    const left = baseAthletes[i]
    const right = incomingAthletes[i]
    if (!left && right) {
      baseAthletes[i] = right
      continue
    }
    if (!left || !right) continue

    if (!left.class && right.class) {
      left.class = right.class
    }
    if ((left.points == null || left.points === '') && right.points != null) {
      left.points = right.points
    }

    const leftName = left.fullName || left.athlete?.fullName || {}
    const rightName = right.fullName || right.athlete?.fullName || {}
    if ((!leftName.lastName || !leftName.firstName) && (rightName.lastName || rightName.firstName)) {
      if ('fullName' in left && left.fullName) {
        left.fullName = { ...left.fullName, ...rightName }
      } else if ('athlete' in left && left.athlete) {
        left.athlete.fullName = { ...(left.athlete.fullName || {}), ...rightName }
      }
    }
  }

  base.athletes = baseAthletes
  return base
}

export const login = async (email, password) => {
  const response = await systemApi.post('/api/auth/login', { email, password })
  setAuthToken(response.data.token)
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem('token', response.data.token)
  }
  setAuthCookie(response.data.token)
  return response.data
}

export const completeTelegramSsoLogin = async code => {
  const token = getAuthToken() || (typeof localStorage !== 'undefined' ? localStorage.getItem('token') : '')
  const response = await systemApi.post(
    '/api/auth/telegram-sso/complete',
    { code },
    token
      ? {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      : undefined
  )
  return response.data
}

export const getMe = async (token) => {
  const res = await systemApi.get('/api/users/me', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return res.data
}
export const getSchedule = (competitonId, isLocal = false, options = {}) => {

  return new Promise((resolve, reject) => {
    competitonId ||= useRoute().params.id
    let url = `competitions/${competitonId}/schedule`
    if(isLocal){
      url = 'local/'+url
    }
    const request = options.forceScrutineer
      ? instance.post(`${url}/scrutineer`, {}, { headers: { Authorization: `Bearer ${getAuthToken()}` } })
      : instance.get(url)
    request
      .then(res => {
        const mapGroup = {}
        const statusGroup = {}
        const timeGroups = {}
        const {data} = res

        data.groups.forEach(g => {
          mapGroup[g.name] = {}
          mapGroup[g.name].currentRound = g?.currentRound?.type
          mapGroup[g.name].name = g.name
          mapGroup[g.name].id = g.id
          statusGroup[g.id] = g.state == 'Ready'
        })
        data.days.map((day)=> {
          day.items.forEach(function(item) {
            if(typeof item == 'object'){
              if ('dance' in item) {
                item = item.dance
              }
              if (item && 'groupId' in item) {
                item = item.groupId
              }
            }
            timeGroups[item] =  parseDate(day.date)
            if(isNaN(timeGroups[item])){
              timeGroups[item] =   new Date(day.date)
            }
          })

        })

        watchersSetter.setStatusGroups(statusGroup)
        watchersSetter.setGroups(mapGroup)
        watchersSetter.setTimeGroups(timeGroups)
        resolve(res)
      })
      .catch(e => {
        console.error(e)
        reject(e)
      })
  })
}
export const getCalendar = (year = new Date().getFullYear()) => {
  return new Promise((resolve, reject) => {
    instance
      .get(`calendar/${year}`)
      .then(res => {
        resolve(res.data)
      })
      .catch(e => {
        console.error(e)
        reject()
      })
  })
}
export const saveScheduleToSystem = async schedule => {
  return await systemApi.post('/api/tournaments/add', schedule)
}
export const getLocalCalendar = () => {
  return new Promise((resolve, reject) => {
    instance
      .get('/local/calendar')
      .then(res => {
        resolve(res.data)
      })
      .catch(e => {
        console.error(e)
        reject()
      })
  })
}
export const getResult = (group, competitonId, local = false) => {
  return new Promise((resolve, reject) => {
    let url = `competitions/${competitonId}/groups/${group.id}/results`
    if(local){
      url = 'local/'+url
    } else if (group?.name) {
      const params = new URLSearchParams()
      params.set('groupName', String(group.name))
      url += `?${params.toString()}`
    }
    instance
      .get(url)
      .then(async resp => {
        const roundsToLoad = []
        const addRound = roundId => {
          if (!roundId) return
          if (!roundsToLoad.includes(roundId)) {
            roundsToLoad.push(roundId)
          }
        }

        const primaryRoundId = group?.searchRoundId || group?.currentRound?.roundId || group?.id
        addRound(primaryRoundId)
        addRound(group?.currentRound?.roundId)
        addRound(group?.id)

        const scrutRoundMatch = String(primaryRoundId || group?.id || group?.currentRound?.roundId || '').match(
          /^scrut_(\d+)_(\d+)_\d+$/
        )
        if (scrutRoundMatch) {
          addRound(`scrut_${scrutRoundMatch[1]}_${scrutRoundMatch[2]}_1`)
        }
        const selectedRounds = roundsToLoad.slice(0, SEARCH_HEATS_MAX_ROUNDS)
        const heatsResponses = []
        for (const roundId of selectedRounds) {
          const heatsData = await instance
            .get(`competitions/${competitonId}/rounds/${roundId}/heats`, {
              timeout: HEATS_REQUEST_TIMEOUT_MS
            })
            .then(i => i?.data || null)
            .catch(() => null)
          heatsResponses.push(heatsData)
          if (Array.isArray(heatsData?.competitors) && heatsData.competitors.length > 0) {
            break
          }
        }

        const merged = new Map()
        const pushOrMerge = competitor => {
          const key = competitorIdentity(competitor)
          if (!key) return
          if (!merged.has(key)) {
            merged.set(key, competitor)
            return
          }
          mergeCompetitorData(merged.get(key), competitor)
        }

        const resultCompetitors = Array.isArray(resp?.data?.competitors)
          ? resp.data.competitors
          : []
        resultCompetitors.forEach(pushOrMerge)

        heatsResponses.forEach(heatsData => {
          const heatsCompetitors = Array.isArray(heatsData?.competitors)
            ? heatsData.competitors
            : []
          heatsCompetitors.forEach(pushOrMerge)
        })

        resp.data.competitors = [...merged.values()]
        resolve(resp.data)
      })
      .catch(e => {
        console.error('@@',e)
        reject()
      })

  })
}

export const getHeats = async (rounds, competitonId) => {
  const { data } = await instance.get(`competitions/${competitonId}/rounds/${rounds}/heats`, {
    timeout: HEATS_REQUEST_TIMEOUT_MS
  })
  return data
}

export const lookupPublicAthlete = async query => {
  const response = await instance.get('public/athletes/lookup', {
    params: {
      q: query
    }
  })
  return response.data
}
